import { useGet } from "@albertine/api-client";
import type { ListAllMembersItem } from "@albertine/types/openapi/lmt";

export const listAllMembersQueryKey = ["listAllMembers"] as const;

export const invalidateListAllMembers = {
    meta: { invalidates: [listAllMembersQueryKey] },
};

export function useMembers() {
    return useGet(
        listAllMembersQueryKey[0],
        {},
        {
            select: (response) => response.items,
        },
    );
}

export function useMembersMap(): Record<string, ListAllMembersItem> {
    const { data: members } = useMembers();
    return Object.fromEntries((members ?? []).map((member) => [member.id, member]));
}
